import classNames from "classnames";
import React, { FC, PropsWithChildren } from "react";
import useTranslations from "../../../hooks/useTranslations";
import { CourseItem } from "../../../models/courses/CourseItem";
import { Checkbox } from "../../Checkbox";
import Select from "../../Select";

export type CourseItemData = {
  id: string;
  name: string;
  course: {
    id: string;
    name: string;
  };
  start_date: string;
  end_date: string;
  location: CourseItem["location"];
  numberOfPlaces: number | string;
  price: string;
  format: string;
};

interface CoursePossibilitiesFiltersProps extends PropsWithChildren {
  className?: string;

  title?: string;
  itemsCount: number;

  locationOptions: Array<{
    title: string;
    value: string;
  }>;
  selectedLocation: string | null;
  onLocationChange: (value: string) => void;

  isBlendedFilterEnabled: boolean;
  onBlendedFilterChange: (enabled: boolean) => void;

  onFilterReset: () => void;

  showBlendedFilter?: boolean;
  showLocationFilter?: boolean;
}

const CoursePossibilitiesFilters: FC<CoursePossibilitiesFiltersProps> = ({
  children,
  className,
  title,
  itemsCount,
  locationOptions,
  selectedLocation,
  onLocationChange,
  isBlendedFilterEnabled,
  onBlendedFilterChange,
  onFilterReset,
  showBlendedFilter,
  showLocationFilter
}) => {
  const translations = useTranslations();

  return (
    <div className={classNames("flex flex-col items-start", className)}>
      {(title || itemsCount > 1) && (
        <div
          className={classNames(
            "flex items-center gap-3",
            !showLocationFilter && "mb-10 md:mb-5"
          )}
        >
          {title && (
            <p className="font-bold text-[1.75rem] text-brand-primary-30 m-0">{title}</p>
          )}
          {itemsCount > 1 && (
            <span className="py-2 px-4 bg-brand-primary-30 text-neutral-100 rounded-full whitespace-nowrap">
              + {itemsCount}
            </span>
          )}
        </div>
      )}
      {(showLocationFilter || showBlendedFilter) && (
        <div className="flex flex-col md:flex-row items-start md:items-center w-full md:justify-between justify-start gap-8 md:gap-0 mt-5 mb-10 md:mb-5">
          {showLocationFilter && (
            <div className="md:w-[35%] w-full">
              <Select
                id="courses-filter-select"
                autoComplete="off"
                options={locationOptions}
                additionalClassName="!mb-0 lg:!mb-0"
                label={translations?.courseLocationFilterLabel ?? "Plats/Stad"}
                onChange={onLocationChange}
                value={selectedLocation}
              />
            </div>
          )}
          {showBlendedFilter && (
            <div className="md:w-[35%] w-full">
              <Checkbox
                label={translations?.courseOnlineFilterLabel!}
                id="courses-filter-checkbox"
                value={String(isBlendedFilterEnabled)}
                onChange={onBlendedFilterChange}
                isControlled
              />
            </div>
          )}
          <div className="text-left md:text-right w-full md:w-[20%]">
            <button
              onClick={onFilterReset}
              className="text-xl underline text-brand-primary-70 underline-offset-4 font-bold"
            >
              {translations?.clearCourseFilters}
            </button>
          </div>
        </div>
      )}
      <div className="w-full">{children}</div>
    </div>
  );
};

export default CoursePossibilitiesFilters;

